// Company & general site pages
import {cdnUrl} from '@/util/cdnImage';
import {CONTACT_EMAIL} from '@/constants/urls';
import type {PageHeadMeta} from '@/components/PageHead';

export const HOME_META_DATA: PageHeadMeta = {
    title: 'Debut Infotech | Digital Transformation & Product Engineering Company',
    img: cdnUrl('meta-images/Hero_Graphic.jpg'),
    description:
        'Debut Infotech empowers startups and enterprises with AI-powered product engineering, software development, blockchain, cloud modernization and digital transformation services.'
};

export const FAQS_META_DATA: PageHeadMeta = {
    title: 'Frequently Asked Questions (FAQs)',
    img: cdnUrl('meta-images/Hero_Graphic.jpg'),
    description:
        'What does Debut Infotech charge, build & deliver? Explore FAQs on pricing, AI, blockchain, MVPs, security, and project process. Have questions? Reach out anytime.'
};

export const CAREER_META_DATA: PageHeadMeta = {
    title: 'Career and Job Opportunities at Debut Infotech',
    img: cdnUrl('meta-images/Hero_Graphic.jpg'),
    description:
        'Explore career and job opportunities at Debut Infotech. Join our team and grow your career with exciting projects and a supportive work environment.'
};

export const CONTACT_US_DATA: PageHeadMeta = {
    title: 'Contact Us | Best Blockchain & Mobile Development Company ',
    description: `We are a leading Mobile and Blockchain development company in US, UK, Canada, and India . Contact us at +1-708-515-4004 | ${CONTACT_EMAIL}`
};

export const PORTFOLIO_META_DATA: PageHeadMeta = {
    title: 'Portfolio | Success Stories of Delivered Digital Solutions',
    description:
        'Check out our blockchain & mobile development solutions portfolio. we have created an array of solutions that have simplified and solved many challenges.'
};

export const ABOUT_US_META: PageHeadMeta = {
    title: 'About Us | Debut Infotech - Top Digital Solutions Provider',
    img: cdnUrl('meta-images/about-banner.jpg'),
    description:
        'Discover Debut Infotech, a top digital solutions provider specializing in blockchain, AI, Tokenization, mobile app, and custom software for global businesses.'
};

export const BLOG_META: PageHeadMeta = {
    title: 'Debut Infotech Blog | Latest Updates, News & Tech Trends',
    description:
        "Read the Debut Infotech's insightful blogs and articles to stay up-to-date with the latest technology trends, innovations, and industry news worldwide."
};

export const PRIVACY_POLICY_META_DATA: PageHeadMeta = {
    title: 'Privacy Policy | Debut Infotech',
    img: cdnUrl('meta-images/Entertainment-banner-img.jpg'),
    description: `Visit this page to know more about our privacy policy and how we collect, use & protect personal information.`
};

export const THANKYOU_META_DATA: PageHeadMeta = {
    title: 'Thank You',
    description:
        'Thank you for choosing Debut Infotech! Your trust means the world to us. Discover the next steps and valuable resources to enhance your experience.'
};

export const USE_META_DATA: PageHeadMeta = {
    title: 'Use Cases | Real-world Applications',
    description:
        'Discover real-world use cases for blockchain, AI and all latest technologies across industries for innovative, efficienct, and digital transformation.'
};

export const CHRISTMAS_OFFER_YEAR: PageHeadMeta = {
    title: 'Christmas Sale: Get 30% OFF on Software Development Solutions',
    img: cdnUrl('Squeeze-offer-page/squeeze-banner.jpg'),
    description:
        'Celebrate Christmas with 30% OFF on premium software solutions. Limited-time offer on Blockchain, wallets, ICOs, IDOs, tokenization, and exchanges!'
};

export const NEWS_META: PageHeadMeta = {
    title: 'Latest Tech News & Press Releases | Debut Infotech',
    description:
        "Stay updated with Debut Infotech's latest news, press releases, company updates, achievements & media coverage from around the world."
};
